<template>
  <div>
      <div class="form-container ou-donation-form">
          <div class="holder">
              <PaymentForm class="form-horizontal">
                  <FormSection title="Donation Frequency">
            <div class="frequency">
              <PaymentOptions addSplit addMonthly :splitMonths="2" monthesSelector/>
            </div>
                  <!-- <DonationFrequency />  -->
                  <TransactionFee />
                </FormSection>           
                  <FormSection title="Personal Information">
                      <FormRow inline>      
                          <FormCol field="title" :flex="1" />
                          <FormCol field="firstName" :flex="2" />
                          <FormCol field="lastName" :flex="2" />
                      </FormRow>
                      <FormRow inline>
                          <FormCol field="email" />
                          <FormCol field="phone" />
                      </FormRow>
                      <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>       

                      </FormSection>
                      <FormSection title="Sponsorship Information">
                      <div>
                      <FormRow>
                      <FormLabel class="control-label">Current Occupation </FormLabel>
                    </FormRow>
                    <FormRow >
                      <FormInput
                        type="text"
                        class="width-half"
                        field="custom.currentOccupation"
                      />
                    </FormRow>   
                      </div>  
                      <br />
                      
                  
                      <div class="listing__area">
                      <FormRow>
                      <FormLabel class="control-label">Listing name for Dedication (Leave blank if anonymous)</FormLabel>
                    </FormRow>
                  
                    <FormRow>
                      <FormInput
                        type="text"
                        class="width-half"
                        field="custom.listingName"
                      />
                    </FormRow> 
                    <FormRow inline>
                            <FormCol width="half" field="dedicationMessage" />
                        </FormRow>                     
                      </div>  
                  </FormSection>
                  <FormSection title="Billing Information">
                      <DonorAddress />
                  </FormSection>
                  <FormSection title="Payment Information" last>
                      <FormRow inline>
                      <FormCol field="card" :showLabel="false"/>
                      </FormRow>
                  </FormSection>
                  <PaymentButton  btnText="Donate Now" showAmount/>
              </PaymentForm>
          </div>
      </div>
  </div>
  </template>
  
  <script lang="ts">
  import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
} from "vue";
  import { usePaymentForm } from '~/shared/use-payment-form'
  
  export default defineComponent({
    setup() {
      const { getValue, setValue, form } = usePaymentForm()

      setValue('amount', '500');

    watch(
      () => form.value.dayOfMonth,
      () => {
        if (form.value.dayOfMonth) {
          setValue('amount', '41.7');
        }
        else{
          setValue('amount', '500');
        }
      });

      return {
        form,
        getValue,
        setValue
      }
    },
  })
  </script>
  <style scoped lang="scss">
  ::v-deep h2 {
    color: #1AA8D3;
    font-weight: bold;
    font-size: 22px;
    margin-bottom: 25px;
  }
  ::v-deep .styled-radio .radio-part {
    min-width:31.333% !important;
    &:nth-child(3) {
      padding-right: 0;
    }
  }

  .listing__area{
    padding-top: 17px;
    border-top: 1px solid #efefef;
    margin-top: 16px;
  }
  </style>
  
  